export default {
  name: 'Marlins Park',
  team: {
    city: 'Miami',
    name: 'Marlins',
    color: '#00A3E0',
    league: 'NL',
    division: 'E',
  },
  walls: [
    {
      min: 0,
      max: 23.7,
      height: -1,
      r: (θ) => -3285.092 / (Math.sin(θ) - (9.80624 * Math.cos(θ))),
    },
    {
      min: 23.7,
      max: 27.1,
      height: -1,
      r: (θ) => 5130.955 / (Math.sin(θ) + (14.1917 * Math.cos(θ))),
    },
    {
      min: 27.1,
      max: 33.1,
      height: -1,
      r: (θ) => 1260.2215 / (Math.sin(θ) + (3.099602 * Math.cos(θ))),
    },
    {
      min: 33.1,
      max: 37.2,
      height: -1,
      r: (θ) => 928.6866 / (Math.sin(θ) + (2.112672 * Math.cos(θ))),
    },
    {
      min: 37.2,
      max: 41.2,
      height: -1,
      r: (θ) => 822.69397 / (Math.sin(θ) + (1.78492 * Math.cos(θ))),
    },
    {
      min: 41.2,
      max: 44.6,
      height: -1,
      r: (θ) => 697.690 / (Math.sin(θ) + (1.380693 * Math.cos(θ))),
    },
    {
      min: 44.6,
      max: 47.9,
      height: -1,
      r: (θ) => 624.24997 / (Math.sin(θ) + (1.1315557 * Math.cos(θ))),
    },
    {
      min: 47.9,
      max: 51.2,
      height: -1,
      r: (θ) => 567.2532 / (Math.sin(θ) + (0.927191 * Math.cos(θ))),
    },
    {
      min: 51.2,
      max: 51.3,
      height: -1,
      r: (θ) => 123.3194 / (Math.sin(θ) - (0.7717922 * Math.cos(θ))),
    },
    {
      min: 51.3,
      max: 51.6,
      height: -1,
      r: (θ) => 163.1114 / (Math.sin(θ) - (0.618006 * Math.cos(θ))),
    },
    {
      min: 51.6,
      max: 52.3,
      height: -1,
      r: (θ) => 263.849 / (Math.sin(θ) - (0.2205658 * Math.cos(θ))),
    },
    {
      min: 52.3,
      max: 53.6,
      height: -1,
      r: (θ) => 333.1776 / (Math.sin(θ) + (0.061447 * Math.cos(θ))),
    },
    {
      min: 53.6,
      max: 55,
      height: -1,
      r: (θ) => 333.04836 / (Math.sin(θ) + (0.06472688 * Math.cos(θ))),
    },
    {
      min: 55,
      max: 56.5,
      height: -1,
      r: (θ) => 391.363 / (Math.sin(θ) + (0.32139203 * Math.cos(θ))),
    },
    {
      min: 56.5,
      max: 59,
      height: -1,
      r: (θ) => 457.485 / (Math.sin(θ) + (0.630953 * Math.cos(θ))),
    },
    {
      min: 59,
      max: 60.8,
      height: -1,
      r: (θ) => 389.587 / (Math.sin(θ) + (0.2903055 * Math.cos(θ))),
    },
    {
      min: 60.8,
      max: 63.6,
      height: -1,
      r: (θ) => 387.8902 / (Math.sin(θ) + (0.281246 * Math.cos(θ))),
    },
    {
      min: 63.6,
      max: 68.2,
      height: -1,
      r: (θ) => 367.932 / (Math.sin(θ) + (0.163124 * Math.cos(θ))),
    },
    {
      min: 68.2,
      max: 72.1,
      height: -1,
      r: (θ) => 360.0411 / (Math.sin(θ) + (0.112519 * Math.cos(θ))),
    },
    {
      min: 72.1,
      max: 79.2,
      height: -1,
      r: (θ) => 349.332 / (Math.sin(θ) + (0.00931917 * Math.cos(θ))),
    },
    {
      min: 79.2,
      max: 84.3,
      height: -1,
      r: (θ) => 339.562 / (Math.sin(θ) - (0.137541 * Math.cos(θ))),
    },
    {
      min: 84.3,
      max: 90,
      height: -1,
      r: (θ) => 337 / (Math.sin(θ) - (0.212114 * Math.cos(θ))),
    },
  ],
};
